import React from 'react'
import './AboutScreen.css'
import AboutBanner from '../assets/images/About/AboutBanner.jpg'
import { FaPhone } from 'react-icons/fa';


function AboutScreen() {
  return (
    <>
      <div className='main-container'>
        <div className="about-container">
          <img src={AboutBanner} alt="About banner" className='about-banner' />
          <div className="about-banner-content">
            <h1>WELCOME TO SHAGAN ARTS</h1>
            <p>A complete signage and branding solutions</p>
          </div>
        </div>
        <div className='about-us my-5 text-center'>
          <h1 className=''>About Us</h1>
          <p className='px-5'>We are one of the leading service provider for Flex printing, Offset, Screen printing, Customized gifts and Accessories, Stamps and other printings. <br /><br />
            Our in depth market knowledge in the respective field enable us to offer our client in efficient manner depending on their business requirement. Our services are highly reliable, effective and flexible. <br /><br />
            We serve the publicity purposes of the clients in a better way thorough our incomparable range of Advertising boards, Hoardings, Display boards, We are here to provide you with a wide range of Best-quality, Full-color banner pinting services at competitive prices.
            <br /><br />
            Our firm was incorporated in the year of 2013. Our team is creative and produces High quality services as per 15+ years of experience in this industry.</p>
        </div>

        {/* Contact Section */}
        <section className="about-contact-section text-center my-5">
          <h2 className="about-contact-heading">Contact for orders</h2>
          <p className="about-contact-info">
            For orders and inquiries, please reach out to us at:<br />
            <a href="tel:+9814067069" className="about-contact-link"><FaPhone className="call-icon" style={{ fontSize: '1.4rem' }} />+91 98140 67069</a><br />
          </p>
        </section>
        
        <section className="certification-section">
          <h2 className="certification-title">Our Certifications</h2>
          <div className="certification-cards">
            <div className="certification-card">
              <h3>Certification 1</h3>
              <p>GST Registered</p>
            </div>
            <div className="certification-card">
              <h3>Certification 2</h3>
              <p>ISO 9001-2015 Registered</p>
            </div>
            <div className="certification-card">
              <h3>Certification 3</h3>
              <p>MSME Registered</p>
            </div>
          </div>
        </section>

      </div>
    </>
  );
}

export default AboutScreen